// https://developer.mozilla.org/en-US/docs/Glossary/Base64#the_unicode_problem
export function base64EncodeUnicode(str) {
  return str == null ? null : window.btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g,
    (match, p1) => String.fromCharCode(`0x${ p1 }`)))
}
